'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _dec3, _class4, _dec4, _class5, _class6, _temp2, _dec5, _class7, _dec6, _class8, _dec7, _class9, _dec8, _class11, _dec9, _class12, _dec10, _class13, _dec11, _class14, _dec12, _class15, _dec13, _class16, _dec14, _class17, _dec15, _class18, _dec16, _class19, _dec17, _class20, _dec18, _class21, _dec19, _class22, _dec20, _class23, _dec21, _class24, _dec22, _class26, _class27, _temp3, _dec23, _class28, _dec24, _class29, _dec25, _class30, _dec26, _class31; /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Things to watch out for:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Images loaded from S3 have 202305 date hardcoded
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * If we get to a point where we are updating monthly,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * we will need to figure out how to have that updated.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Maybe from Version.json?
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactSlidedown = require('react-slidedown');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _FossilFuelBondsIn401ks = require('./FossilFuelBondsIn401ks.css');

var _FossilFuelBondsIn401ks2 = _interopRequireDefault(_FossilFuelBondsIn401ks);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _fossilFuelBondsSocialShare = require('../../../static/images/fossil-fuel-bonds-social-share.png');

var _fossilFuelBondsSocialShare2 = _interopRequireDefault(_fossilFuelBondsSocialShare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// used to control chart image loading from S3
var currYYYYMM = '202305';

// function aliases
// fm -> format.money
var fm = function fm(m) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  return _format2.default.money(m, true, 'USD', true, 2);
};
// fp -> format.perc
var fp = function fp(p) {
  var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return _format2.default.perc(p, round, decimals);
};

//
//
//
//
//
//
/**
 * <LedeNav> component
 * Display: layout, headline, text of lede at top of page,
 *          Nav with <ScrollLink> to scroll down to findings, results, etc.
 * @param title: Page/window title
 */
var LedeNav = (_dec = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LedeNav, _Component);

  function LedeNav() {
    (0, _classCallCheck3.default)(this, LedeNav);
    return (0, _possibleConstructorReturn3.default)(this, (LedeNav.__proto__ || (0, _getPrototypeOf2.default)(LedeNav)).apply(this, arguments));
  }

  (0, _createClass3.default)(LedeNav, [{
    key: 'render',
    value: function render() {
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'lede-wrap' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'lede-h1-wrap' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.title
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'lede-nav-flex' },
            _react2.default.createElement(
              'nav',
              { styleName: 'scroll-nav-btn-wrap' },
              [['issue', 'The bond problem'], ['key-findings', 'Key findings'], ['retirement-plans', 'Retirement plans'], ['target-dates', 'Target date series'], ['recommendations', 'Recommendations'], ['methodology', 'Methodology']].map(function (s, i) {
                return _react2.default.createElement(
                  _reactScroll.Link,
                  {
                    activeClass: 'active-scroll-link',
                    to: s[0],
                    key: 'scroll-link-' + s[0],
                    spy: true,
                    smooth: true,
                    offset: -70,
                    duration: 500
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'scroll-nav-btn' },
                    s[1]
                  )
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lede-p-wrap' },
              _react2.default.createElement(
                'p',
                null,
                'Retirement plans don\'t just invest in stocks of high-carbon companies. They also hold corporate bonds issued by those same companies. Corporate bonds are one of the main ways fossil fuel companies raise money to expand their operations.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'If there are fossil fuel bonds in your 401(k), you\'re effectively lending your retirement savings to companies so they can mine for coal and drill for oil.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'lede-ays-logo-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.links.ays,
                title: 'As You Sow'
              },
              _react2.default.createElement('img', {
                src: aysLogo,
                alt: 'As You Sow',
                styleName: 'lede-ays-logo'
              }),
              _react2.default.createElement(
                _components.SrOnly,
                null,
                'As You Sow'
              )
            )
          )
        )
      );
    }
  }]);
  return LedeNav;
}(_react.Component), _class2.propTypes = {
  title: _react.PropTypes.string.isRequired
}, _temp)) || _class);

//
// <TheIssue> component
// Display: 3 circle images w/ captions,
//          button link to Bond Climate Risks page
//

var TheIssue = (_dec2 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(TheIssue, _Component2);

  function TheIssue() {
    (0, _classCallCheck3.default)(this, TheIssue);
    return (0, _possibleConstructorReturn3.default)(this, (TheIssue.__proto__ || (0, _getPrototypeOf2.default)(TheIssue)).apply(this, arguments));
  }

  (0, _createClass3.default)(TheIssue, [{
    key: 'render',
    value: function render() {
      var icon1 = require('../../../static/images/bonds-issue-circle-1.png');
      var icon2 = require('../../../static/images/bonds-issue-circle-2.png');
      var icon3 = require('../../../static/images/bonds-issue-circle-3.png');
      return _react2.default.createElement(
        'div',
        { styleName: 'issue-wrap', id: 'issue' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h2',
            null,
            'The bond problem'
          ),
          _react2.default.createElement(
            'div',
            { styleName: '_123-flex' },
            [[icon1, 'Fossil fuel companies issue bonds', _react2.default.createElement(
              'span',
              null,
              'Fossil fuel companies issue bonds to raise money to develop new coal, oil, and gas projects. Retirement plans invest employee savings in those bonds.'
            )], [icon2, 'There can be no new coal, oil, and gas development', _react2.default.createElement(
              'span',
              null,
              'The International Energy Agency has warned that there can be no new coal, oil, and gas development if humanity wants to prevent dangerous warming.'
            )], [icon3, 'Savers face the risk of climate-related financial losses', _react2.default.createElement(
              'span',
              null,
              'Those who have invested in fossil fuel companies, including people who have purchased the companies\u2019 stocks or bonds, face the risk of climate-related financial losses.'
            )]].map(function (e, i11) {
              var _e = (0, _slicedToArray3.default)(e, 3),
                  icon = _e[0],
                  altText = _e[1],
                  text = _e[2];

              return _react2.default.createElement(
                'div',
                { styleName: '_123-cell', key: 'issue-cell-' + i11 },
                _react2.default.createElement(
                  'div',
                  { styleName: '_123-image' },
                  _react2.default.createElement('img', { src: icon, alt: altText })
                ),
                _react2.default.createElement(
                  'h3',
                  { styleName: '_123-copy' },
                  text
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'issue-risk-link-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.fossilFuelBondRisks,
                title: 'Financial risks of fossil fuel bonds'
              },
              _react2.default.createElement(
                'div',
                { styleName: 'issue-risk-link' },
                'Financial risks of fossil fuel bonds',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          ),
          _react2.default.createElement(_components.ScrollToTop, { color: 'red' })
        )
      );
    }
  }]);
  return TheIssue;
}(_react.Component)) || _class3);

//
// <KeyFindings> component
// Display: text framing key findings
// Includes: <BulletAccordion> of key findings
//

var KeyFindings = (_dec3 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec3(_class4 = function (_Component3) {
  (0, _inherits3.default)(KeyFindings, _Component3);

  function KeyFindings() {
    (0, _classCallCheck3.default)(this, KeyFindings);
    return (0, _possibleConstructorReturn3.default)(this, (KeyFindings.__proto__ || (0, _getPrototypeOf2.default)(KeyFindings)).apply(this, arguments));
  }

  (0, _createClass3.default)(KeyFindings, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'key-findings-wrap', id: 'key-findings' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Key findings'
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'key-findings-col-left' },
                _react2.default.createElement(
                  'p',
                  null,
                  'As many banks start to limit their lending to carbon intensive industries, companies in the coal, oil, and gas value chain are turning more to the bond market to access cheap debt. Every time retirement plan participants invest in fossil fuel corporate bonds, they are helping new coal plants, new oil and gas pipelines, and other new fossil fuel infrastructure get built.'
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'key-findings-col-right' },
                _react2.default.createElement(BulletAccordion, { bullets: [['Invested in fossil fuel bonds by default', 'Large diversified target date fund series are often the default option in employer-offered retirement plans. These fund series generally hold many fossil fuel corporate bonds and aren\'t reducing exposure on the basis of climate risk.'], ['Few climate-safe bond fund options', 'Some plans offer treasury or other government bond fund options, but few offer sustainable diversified bond funds.'], ['Employees closer to retirement are more at risk of fossil fuel bond exposure', 'As people get closer to retirement, their allocation usually becomes more bond-heavy, meaning their risk of investing in fossil fuel bonds rises.'], ['Higher fossil fuel concentrations in bonds than stocks', 'Retirement plans generally have significantly more invested in stocks than bonds, but within the equity and corporate bond asset classes, fossil fuel concentrations are higher for bonds. For most of the plans analyzed, upwards of 15% of corporate bond holdings were fossil fuel.']] })
              )
            )
          ),
          _react2.default.createElement(_components.ScrollToTop, { color: 'red' })
        )
      );
    }
  }]);
  return KeyFindings;
}(_react.Component)) || _class4);

/**
 * <BulletAccordion> component
 * Layout and state management for bullet accordion
 * @param bullets
 */

var BulletAccordion = (_dec4 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec4(_class5 = (_temp2 = _class6 = function (_Component4) {
  (0, _inherits3.default)(BulletAccordion, _Component4);

  function BulletAccordion(props) {
    (0, _classCallCheck3.default)(this, BulletAccordion);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (BulletAccordion.__proto__ || (0, _getPrototypeOf2.default)(BulletAccordion)).call(this, props));

    _this4.state = {
      /** Number tracking which bullet point is open */
      open: null
    };
    return _this4;
  }
  /**
   * Open a particular bullet point slidedown.
   *
   * @param {Number} [i=null] Index of the bullet to open (or close if
   *                          already open).
   */


  (0, _createClass3.default)(BulletAccordion, [{
    key: 'openBullet',
    value: function openBullet() {
      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.state.open !== i) {
        this.setState({ open: i });
      } else {
        this.setState({ open: null });
      }
    }
    //

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!this.props.bullets) {
        return null;
      }
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'fa-wrap' },
        this.props.bullets.map(function (bullet, bulletIdx) {
          var k = 'findings-accordion-bullet-' + bulletIdx;
          return _react2.default.createElement(
            'div',
            { key: k, styleName: 'fa-item-wrap' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'fa-bullet',
                onClick: function onClick() {
                  _this5.openBullet(bulletIdx);
                }
              },
              _react2.default.createElement(
                'div',
                { styleName: 'fa-bullet-text' },
                bullet[0]
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.LinkIcon, { faclass: _this5.state.open === bulletIdx ? 'fa-close' : 'fa-plus', nospace: true })
              )
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              _this5.state.open === bulletIdx ? _react2.default.createElement(
                'div',
                { styleName: 'fa-slidedown' },
                bullet[1]
              ) : null
            )
          );
        })
      );
    }
  }]);
  return BulletAccordion;
}(_react.Component), _class6.propTypes = {
  /**
   * List of bullets and slidedown content. Each item in list
   * is a list of two items, first item is bullet content,
   * second item is slidedown content.
   */
  bullets: _react.PropTypes.array.isRequired
}, _temp2)) || _class5);

//
// <PlanSection> component
// Layout for plan section
// Display: some text and callout quotes
// Includes: <PlanSectionExposureConcentrationChart>
//           <PlanSelect>
//           <PlanBondFundsTableLayout>
//

var PlanSection = (_dec5 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec5(_class7 = function (_Component5) {
  (0, _inherits3.default)(PlanSection, _Component5);

  function PlanSection() {
    (0, _classCallCheck3.default)(this, PlanSection);
    return (0, _possibleConstructorReturn3.default)(this, (PlanSection.__proto__ || (0, _getPrototypeOf2.default)(PlanSection)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanSection, [{
    key: 'render',
    value: function render() {
      var iconPlans = require('../../../static/images/icon-plans.png');
      //
      return _react2.default.createElement(
        'div',
        { id: 'retirement-plans' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'plan-select-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'plan-select-flex' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  null,
                  'Retirement plans'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'While retirement plans have lower ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'exposure'
                  ),
                  ' to fossil fuel bonds than fossil fuel stocks, the ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'concentration'
                  ),
                  ' of fossil fuels is higher within corporate bond holdings than within stocks.'
                )
              ),
              _react2.default.createElement('img', {
                styleName: 'plan-select-img',
                src: iconPlans,
                alt: 'Retirement plans - 401(k)s & 403(b)s'
              })
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'plan-select-concentration-summary' },
              'In U.S. 401(k)s and similar retirement plans, any given dollar invested in corporate bonds is almost ',
              _react2.default.createElement(
                'span',
                null,
                'twice as likely to be fossil fuel'
              ),
              ' compared to a dollar invested in stocks.'
            ),
            _react2.default.createElement(PlanSectionExposureConcentrationChart, null),
            _react2.default.createElement(
              'h3',
              { styleName: 'plan-select-aggregate-summary' },
              'With $9.3 trillion invested in U.S. 401(k)s and similar retirement plans, an average fossil fuel bond exposure of 0.5% would amount to an estimated ',
              _react2.default.createElement(
                'span',
                null,
                '$46.5 billion invested in fossil fuel bonds'
              ),
              ' by U.S. defined contribution plan participants.'
            ),
            _react2.default.createElement(PlanSelect, null),
            _react2.default.createElement(PlanBondFundsTableLayout, null)
          ),
          _react2.default.createElement(_components.ScrollToTop, { color: 'red' })
        )
      );
    }
  }]);
  return PlanSection;
}(_react.Component)) || _class7);

//
// <PlanSectionExposureConcentrationChart> component
// Display: exposure + concentration chart,
//          exposure + concentration explainers,
//          exposure + concentration table
//

var PlanSectionExposureConcentrationChart = (_dec6 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec6(_class8 = function (_Component6) {
  (0, _inherits3.default)(PlanSectionExposureConcentrationChart, _Component6);

  function PlanSectionExposureConcentrationChart(props) {
    (0, _classCallCheck3.default)(this, PlanSectionExposureConcentrationChart);

    var _this7 = (0, _possibleConstructorReturn3.default)(this, (PlanSectionExposureConcentrationChart.__proto__ || (0, _getPrototypeOf2.default)(PlanSectionExposureConcentrationChart)).call(this, props));

    _this7.state = {
      avgExposureBond: 0.005,
      avgExposureEquity: 0.062,
      avgConcentrationBond: 0.15,
      avgConcentrationEquity: 0.086
    };
    return _this7;
  }
  //


  (0, _createClass3.default)(PlanSectionExposureConcentrationChart, [{
    key: 'render',
    value: function render() {
      var exposureConcentrationChart = require('../../../static/images/Fossil fuel stocks and bonds in 401ks.png');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'plan-select-exposure-concentration-chart-flex' },
        _react2.default.createElement('img', {
          styleName: 'plan-select-exposure-concentration-chart',
          src: exposureConcentrationChart,
          alt: 'Fossil fuel stocks and bonds in 401(k)s'
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'plan-select-exposure-concentration-chart-disclaimer' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Exposure'
            ),
            ': The percentage of plan assets invested in fossil fuel bonds or fossil fuel stocks. Most plans have over 10 times more invested in fossil fuel stocks than fossil fuel bonds.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Concentration'
            ),
            ': The percentage of plan assets classified as fossil fuel within each asset class. In other words, for most retirement plans, a dollar invested in corporate bonds is about twice as likely to be fossil fuel compared to any given dollar invested in stocks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Figures in the chart and table represent the average of the 43 retirement plans analyzed below.'
          ),
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement('th', null),
                _react2.default.createElement(
                  'th',
                  null,
                  'Bond'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Equity'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Avg. fossil fuel exposure'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  fp(this.state.avgExposureBond)
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  fp(this.state.avgExposureEquity)
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  'Avg. fossil fuel concentration'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  fp(this.state.avgConcentrationBond)
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  fp(this.state.avgConcentrationEquity)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PlanSectionExposureConcentrationChart;
}(_react.Component)) || _class8);

//
// <PlanSelect> component
// Transforms config.plansBondsSource into a planData object
// Includes: <SelectDropdownPlan> and onPlanSelect()
//             to select an active plan,
//           <PlanResults> to display results
//             for active plan
//

var PlanSelect = (_dec7 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec7(_class9 = function (_Component7) {
  (0, _inherits3.default)(PlanSelect, _Component7);

  function PlanSelect(props) {
    (0, _classCallCheck3.default)(this, PlanSelect);

    var _this8 = (0, _possibleConstructorReturn3.default)(this, (PlanSelect.__proto__ || (0, _getPrototypeOf2.default)(PlanSelect)).call(this, props));

    _this8.onPlanSelect = function (val) {
      // clear the timeout
      // this is in case user changes select before prev
      // timeout has finished
      if (_this8.state.planTimeout) {
        clearTimeout(_this8.state.planTimeout);
      }
      var timeoutLen = 500;
      var scrollOffset = -70;
      var scrollDuration = 500;
      if (val) {
        // if we selected a value:
        // set the state so that the selected value is on the select
        // so that the loading icon is showing
        // so that nothing is open
        // and start a timeout for 1 second
        // after 1 second, hide the loading icon
        // and open the results
        _reactScroll.scroller.scrollTo('scroll-to', {
          duration: scrollDuration,
          delay: 0,
          smooth: 'easeInOutQuart',
          offset: scrollOffset
        });
        _this8.setState({
          planSelected: val,
          planLoading: true,
          planTimeout: setTimeout(function () {
            _this8.setState({
              planLoading: false
            });
          }, timeoutLen)
        });
      } else {
        // if didn't select a value
        // set selected value to default option
        // set loading icon to off
        // nothing should be showing
        // and there is no timeout.
        _reactScroll.scroller.scrollTo('scroll-to', {
          duration: scrollDuration,
          delay: 0,
          smooth: 'easeInOutQuart',
          offset: scrollOffset
        });
        _this8.setState({
          planSelected: { name: 'Select a plan', label: 'Select a plan' },
          planLoading: true,
          planTimeout: setTimeout(function () {
            _this8.setState({
              planLoading: false
            });
          }, timeoutLen)
        });
      }
    };

    var plansData = (0, _keys2.default)(_config2.default.plansBondsSource).map(function (key, i) {
      var a = _config2.default.plansSource[key];
      var b = _config2.default.plansBondsSource[key];
      return {
        plan_option_count: a.plan_option_count,
        plan_assets: a.plan_assets,
        primary_plan_name: a.primary_plan_name,
        short_name: a.short_name,
        logo: require('../../../static/images/plans/' + a.path + '.png'),
        key: key,
        // from plansBondsSource
        unmatched_funds_count: b.unmatched_funds_count,
        unmatched_fund_assets: b.unmatched_fund_assets,
        unmatched_fund_weight: b.unmatched_fund_weight,
        matched_funds_count: b.matched_funds_count,
        matched_fund_assets: b.matched_fund_assets,
        matched_fund_weight: b.matched_fund_weight,
        long_equity_assets: b.long_equity_assets,
        long_cbond_assets: b.long_cbond_assets,
        ff_all_asset_bond: b.ff_all_asset_bond,
        ff_all_weight_bond: b.ff_all_weight_bond,
        ff_all_weight_bond_concentration: b.ff_all_weight_bond_concentration,
        ff_all_asset_equity: b.ff_all_asset_equity,
        ff_all_weight_equity: b.ff_all_weight_equity,
        ff_all_weight_equity_concentration: b.ff_all_weight_equity_concentration,
        ff_all_asset_both: b.ff_all_asset_equity_and_bond,
        ff_all_weight_both: b.ff_all_weight_equity_and_bond,
        top_cbond_companies_in_plan: b.top_cbond_companies_in_plan,
        // from planOptionsBondsSource
        plan_options_table: _config2.default.planOptionsBondsSource[key]
      };
    });
    _this8.state = {
      plansData: plansData,
      planSelected: {
        name: 'Select a plan',
        label: 'Select a plan'
      },
      planLoading: false,
      planTimeout: null
    };
    return _this8;
  }

  (0, _createClass3.default)(PlanSelect, [{
    key: 'render',
    value: function render() {
      var _this9 = this;

      // select active plan
      var activePlan = null;
      if (this.state.planSelected.name !== 'Select a plan') {
        activePlan = this.state.plansData.find(function (plan) {
          return _this9.state.planSelected.name === plan.key;
        });
      }
      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Use the dropdown or click a row on the table to see details on how much that retirement plan has invested in fossil fuel bonds and stocks, as well as details on each plan option.'
        ),
        _react2.default.createElement('div', { id: 'scroll-to' }),
        _react2.default.createElement(_components.SelectDropdownPlan, {
          plans: _config2.default.plansBondsSource,
          value: this.state.planSelected,
          onChange: this.onPlanSelect
        }),
        _react2.default.createElement(PlanResults, {
          planLoading: this.state.planLoading,
          plansData: this.state.plansData,
          activePlan: activePlan,
          onPlanSelect: this.onPlanSelect
        })
      );
    }
  }]);
  return PlanSelect;
}(_react.Component)) || _class9);

//
// <PlanResults> component
//
// @param planLoading:
// @param activePlan:
// @param plansData:
// @param onPlanSelect:
//

var PlanResults = (_dec8 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec8(_class11 = function (_Component8) {
  (0, _inherits3.default)(PlanResults, _Component8);

  function PlanResults() {
    (0, _classCallCheck3.default)(this, PlanResults);
    return (0, _possibleConstructorReturn3.default)(this, (PlanResults.__proto__ || (0, _getPrototypeOf2.default)(PlanResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanResults, [{
    key: 'render',
    value: function render() {
      var _this11 = this;

      return _react2.default.createElement(
        'div',
        null,
        /* LOADING ICON DURING PLAN SELECT TIMEOUT */
        this.props.planLoading ? _react2.default.createElement(
          'div',
          { styleName: 'plan-loader-wrap' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '50px' },
            loaded: false
          })
        ) : null,

        /* LIST OF PLANS*/
        !this.props.planLoading && !this.props.activePlan ? _react2.default.createElement(
          'div',
          { styleName: 'plan-list' },
          this.props.plansData.map(function (plan, planI) {
            return _react2.default.createElement(
              'div',
              { key: 'plan-list-row-' + planI },
              !(planI % 10) ? _react2.default.createElement(
                'div',
                { styleName: 'plan-list-row-header' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'plan-list-row-header-row-header' },
                  _react2.default.createElement(
                    'div',
                    null,
                    '\xA0'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'Fossil fuel bonds'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'plan-list-row-header-row' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'Employer'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      'Investments'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      'Exposure'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      'Concentration'
                    )
                  )
                )
              ) : null,
              _react2.default.createElement(
                'div',
                {
                  styleName: 'plan-list-row',
                  key: 'plan-select-list-' + planI,
                  onClick: function onClick() {
                    _this11.props.onPlanSelect({
                      name: plan.key,
                      label: plan.short_name
                    });
                  }
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'plan-list-logo-wrap' },
                  _react2.default.createElement('img', {
                    src: plan.logo,
                    alt: plan.short_name,
                    styleName: 'plan-list-logo'
                  }),
                  _react2.default.createElement(
                    _components.SrOnly,
                    null,
                    plan.short_name
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  fm(plan.ff_all_asset_bond)
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  fp(plan.ff_all_weight_bond)
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red' },
                    fp(plan.ff_all_weight_bond_concentration)
                  )
                )
              )
            );
          })
        ) : null,
        /* PLAN RESULTS */
        !this.props.planLoading && this.props.activePlan ? _react2.default.createElement(
          'div',
          { styleName: 'plan-summary-wrap', id: this.props.activePlan.key },
          _react2.default.createElement(
            'div',
            {
              styleName: 'plan-summary-back-to-list',
              onClick: function onClick() {
                _this11.props.onPlanSelect({
                  name: 'Select a plan',
                  label: 'Select a plan'
                });
              }
            },
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-arrow-left' }),
            '\xA0 Back to list'
          ),
          _react2.default.createElement(PlanSummary, { activePlan: this.props.activePlan }),
          _react2.default.createElement(PlanCharts, { activePlan: this.props.activePlan }),
          _react2.default.createElement(PlanOptionsTableLayout, { activePlan: this.props.activePlan }),
          _react2.default.createElement(
            'div',
            {
              styleName: 'plan-summary-back-to-list',
              onClick: function onClick() {
                _this11.props.onPlanSelect({
                  name: 'Select a plan',
                  label: 'Select a plan'
                });
              }
            },
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-arrow-left' }),
            '\xA0 Back to list'
          )
        ) : null
      );
    }
  }]);
  return PlanResults;
}(_react.Component)) || _class11);

//
// <PlanSummary> component
// Layout for plan summary, including desktop/tablet and mobile
// Includes: <PlanSummaryLogo>,
//           <PlanSummaryNameSize>,
//           <PlanSummaryTopFossilFuelBondHoldings>,
//           <PlanSummaryFossilFuelInvestments>
// @param activePlan: Object of active plan from <PlanSelect>
//

var PlanSummary = (_dec9 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec9(_class12 = function (_Component9) {
  (0, _inherits3.default)(PlanSummary, _Component9);

  function PlanSummary() {
    (0, _classCallCheck3.default)(this, PlanSummary);
    return (0, _possibleConstructorReturn3.default)(this, (PlanSummary.__proto__ || (0, _getPrototypeOf2.default)(PlanSummary)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanSummary, [{
    key: 'render',
    value: function render() {
      if (!this.props.activePlan) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 6 },
            _react2.default.createElement(PlanSummaryLogo, { activePlan: this.props.activePlan })
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 6 },
            _react2.default.createElement(PlanSummaryNameSize, { activePlan: this.props.activePlan })
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'hidden-xs' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { sm: 6 },
              _react2.default.createElement(PlanSummaryTopFossilFuelBondHoldings, { activePlan: this.props.activePlan })
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { sm: 6 },
              _react2.default.createElement(PlanSummaryFossilFuelInvestments, { activePlan: this.props.activePlan })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'visible-xs' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 0 },
              _react2.default.createElement(PlanSummaryFossilFuelInvestments, { activePlan: this.props.activePlan })
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 0 },
              _react2.default.createElement(PlanSummaryTopFossilFuelBondHoldings, { activePlan: this.props.activePlan })
            )
          )
        )
      );
    }
  }]);
  return PlanSummary;
}(_react.Component)) || _class12);

//
// <PlanSummaryLogo> component
// Display: image of plan logo
// @param activePlan: Object of active plan from <PlanSelect>
//

var PlanSummaryLogo = (_dec10 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec10(_class13 = function (_Component10) {
  (0, _inherits3.default)(PlanSummaryLogo, _Component10);

  function PlanSummaryLogo() {
    (0, _classCallCheck3.default)(this, PlanSummaryLogo);
    return (0, _possibleConstructorReturn3.default)(this, (PlanSummaryLogo.__proto__ || (0, _getPrototypeOf2.default)(PlanSummaryLogo)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanSummaryLogo, [{
    key: 'render',
    value: function render() {
      if (!this.props.activePlan) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'plan-summary-col' },
        _react2.default.createElement(
          'h3',
          { styleName: 'plan-summary-section-heading' },
          'EMPLOYER'
        ),
        _react2.default.createElement('img', {
          src: this.props.activePlan.logo,
          alt: this.props.activePlan.short_name,
          styleName: 'plan-summary-logo'
        })
      );
    }
  }]);
  return PlanSummaryLogo;
}(_react.Component)) || _class13);

//
// <PlanSummaryNameSize> component
// Display: name, size of plan
// @param activePlan: Object of active plan from <PlanSelect>
//

var PlanSummaryNameSize = (_dec11 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec11(_class14 = function (_Component11) {
  (0, _inherits3.default)(PlanSummaryNameSize, _Component11);

  function PlanSummaryNameSize(props) {
    (0, _classCallCheck3.default)(this, PlanSummaryNameSize);
    return (0, _possibleConstructorReturn3.default)(this, (PlanSummaryNameSize.__proto__ || (0, _getPrototypeOf2.default)(PlanSummaryNameSize)).call(this, props));
  }

  (0, _createClass3.default)(PlanSummaryNameSize, [{
    key: 'render',
    value: function render() {
      if (!this.props.activePlan) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'plan-summary-col' },
          _react2.default.createElement(
            'h3',
            { styleName: 'plan-summary-section-heading' },
            'PLAN NAME'
          ),
          _react2.default.createElement(
            'p',
            null,
            this.props.activePlan.primary_plan_name
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'plan-summary-col' },
          _react2.default.createElement(
            'h3',
            { styleName: 'plan-summary-section-heading' },
            'PLAN SIZE'
          ),
          _react2.default.createElement(
            'p',
            null,
            fm(this.props.activePlan.plan_assets),
            ' invested in ',
            this.props.activePlan.plan_option_count,
            ' plan options'
          )
        )
      );
    }
  }]);
  return PlanSummaryNameSize;
}(_react.Component)) || _class14);

//
// <PlanSummaryTopFossilFuelBondHoldings> component
// Display: table of top fossil fuel bond holdings
// @param activePlan: Object of active plan from <PlanSelect>
//

var PlanSummaryTopFossilFuelBondHoldings = (_dec12 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec12(_class15 = function (_Component12) {
  (0, _inherits3.default)(PlanSummaryTopFossilFuelBondHoldings, _Component12);

  function PlanSummaryTopFossilFuelBondHoldings() {
    (0, _classCallCheck3.default)(this, PlanSummaryTopFossilFuelBondHoldings);
    return (0, _possibleConstructorReturn3.default)(this, (PlanSummaryTopFossilFuelBondHoldings.__proto__ || (0, _getPrototypeOf2.default)(PlanSummaryTopFossilFuelBondHoldings)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanSummaryTopFossilFuelBondHoldings, [{
    key: 'render',
    value: function render() {
      var _this16 = this;

      if (!this.props.activePlan) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'plan-summary-col' },
        _react2.default.createElement(
          'h3',
          { styleName: 'plan-summary-section-heading' },
          'TOP FOSSIL FUEL BOND HOLDINGS'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Top fossil fuel corporate bond issuers within plan options'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'top-companies-ol' },
          this.props.activePlan.top_cbond_companies_in_plan.map(function (c, i2) {
            return _react2.default.createElement(
              'div',
              {
                key: 'top_cbond_companies_' + _this16.props.activePlan.key + '_' + i2,
                styleName: 'top-companies-li'
              },
              _react2.default.createElement(
                'div',
                { styleName: 'top-companies-li-flex' },
                _react2.default.createElement(
                  'div',
                  null,
                  i2 + 1,
                  '.'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  c[0]
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  fm(c[1])
                )
              )
            );
          })
        )
      );
    }
  }]);
  return PlanSummaryTopFossilFuelBondHoldings;
}(_react.Component)) || _class15);
var PlanSummaryFossilFuelInvestments = (_dec13 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec13(_class16 = function (_Component13) {
  (0, _inherits3.default)(PlanSummaryFossilFuelInvestments, _Component13);

  function PlanSummaryFossilFuelInvestments(props) {
    (0, _classCallCheck3.default)(this, PlanSummaryFossilFuelInvestments);
    return (0, _possibleConstructorReturn3.default)(this, (PlanSummaryFossilFuelInvestments.__proto__ || (0, _getPrototypeOf2.default)(PlanSummaryFossilFuelInvestments)).call(this, props));
  }

  (0, _createClass3.default)(PlanSummaryFossilFuelInvestments, [{
    key: 'render',
    value: function render() {
      if (!this.props.activePlan) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'fossil-fuel-investments-summary-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'plan-summary-heading-col' },
          _react2.default.createElement(
            'h3',
            { styleName: 'plan-summary-section-heading' },
            'FOSSIL FUEL INVESTMENTS'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'plan-summary-col' },
          _react2.default.createElement(
            'p',
            { styleName: 'plan-summary-data-section-heading' },
            _react2.default.createElement(
              'i',
              null,
              'CORPORATE BONDS'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-stat-flex' },
            _react2.default.createElement(
              'div',
              null,
              'Investments'
            ),
            _react2.default.createElement(
              'div',
              null,
              fm(this.props.activePlan.ff_all_asset_bond)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-stat-flex' },
            _react2.default.createElement(
              'div',
              null,
              'Exposure',
              _react2.default.createElement(
                'div',
                null,
                'Out of ',
                fm(this.props.activePlan.plan_assets),
                ' invested in all plan options'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              fp(this.props.activePlan.ff_all_weight_bond)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-stat-flex' },
            _react2.default.createElement(
              'div',
              null,
              'Concentration',
              _react2.default.createElement(
                'div',
                null,
                'Out of ',
                fm(this.props.activePlan.long_cbond_assets),
                ' invested in corporate bonds'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { styleName: 'red' },
                fp(this.props.activePlan.ff_all_weight_bond_concentration)
              )
            )
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'plan-summary-data-section-heading' },
            _react2.default.createElement(
              'i',
              null,
              'EQUITIES (STOCKS)'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-stat-flex' },
            _react2.default.createElement(
              'div',
              null,
              'Investments'
            ),
            _react2.default.createElement(
              'div',
              null,
              fm(this.props.activePlan.ff_all_asset_equity)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-stat-flex' },
            _react2.default.createElement(
              'div',
              null,
              'Exposure',
              _react2.default.createElement(
                'div',
                null,
                'Out of ',
                fm(this.props.activePlan.plan_assets),
                ' invested in all plan options'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              fp(this.props.activePlan.ff_all_weight_equity)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-stat-flex' },
            _react2.default.createElement(
              'div',
              null,
              'Concentration',
              _react2.default.createElement(
                'div',
                null,
                'Out of ',
                fm(this.props.activePlan.long_equity_assets),
                ' invested in stocks'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { styleName: 'red' },
                fp(this.props.activePlan.ff_all_weight_equity_concentration)
              )
            )
          )
        )
      );
    }
  }]);
  return PlanSummaryFossilFuelInvestments;
}(_react.Component)) || _class16);
var PlanCharts = (_dec14 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec14(_class17 = function (_Component14) {
  (0, _inherits3.default)(PlanCharts, _Component14);

  function PlanCharts(props) {
    (0, _classCallCheck3.default)(this, PlanCharts);

    var _this18 = (0, _possibleConstructorReturn3.default)(this, (PlanCharts.__proto__ || (0, _getPrototypeOf2.default)(PlanCharts)).call(this, props));

    var activePlan = _this18.props.activePlan;

    var urlPrefix = 'https://iyv-charts.s3-us-west-2.amazonaws.com/fossil_fuel_bonds/';
    var planWeightChartUrl = '' + urlPrefix + activePlan.primary_plan_name + ' fossil fuel bonds weight ' + currYYYYMM + '.png';
    var planWeightChartAlt = activePlan.primary_plan_name + ' weight chart';
    var planAssetChartUrl = '' + urlPrefix + activePlan.primary_plan_name + ' fossil fuel bonds assets ' + currYYYYMM + '.png';
    var planAssetChartAlt = activePlan.primary_plan_name + ' assets chart';
    _this18.state = {
      isAssetChart: null,
      planWeightChartUrl: planWeightChartUrl,
      planWeightChartAlt: planWeightChartAlt,
      planAssetChartUrl: planAssetChartUrl,
      planAssetChartAlt: planAssetChartAlt
    };
    return _this18;
  }

  (0, _createClass3.default)(PlanCharts, [{
    key: 'render',
    value: function render() {
      var _this19 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'plan-charts-wrap' },
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 8 },
            _react2.default.createElement(
              'h3',
              { styleName: 'plan-summary-section-heading' },
              'PLAN INVESTMENT OPTIONS'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Here is a list of the funds offered by this employer\'s plan. You can sort by the fund\'s percent exposure to fossil fuels, or the amount plan participants have invested in fossil fuels via that plan option.'
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 4 },
            _react2.default.createElement(
              'div',
              { styleName: 'chart-button-flex-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'chart-button-flex-cell' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'chart-button-label-flex' },
                  _react2.default.createElement(
                    'i',
                    null,
                    'Chart type'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'chart-button-flex' },
                  _react2.default.createElement(
                    'label',
                    { styleName: 'toggle' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'toggle-label' },
                      'Percent'
                    ),
                    _react2.default.createElement('input', {
                      styleName: 'toggle-checkbox',
                      type: 'checkbox',
                      checked: this.state.isAssetChart,
                      onClick: function onClick() {
                        _this19.setState({
                          isAssetChart: !_this19.state.isAssetChart
                        });
                      }
                    }),
                    _react2.default.createElement('div', { styleName: 'toggle-switch' }),
                    _react2.default.createElement(
                      'span',
                      { styleName: 'toggle-label' },
                      'USD $'
                    )
                  )
                )
              )
            )
          )
        ),
        /* CHART IMAGE 1 - BY WEIGHT */
        !this.state.isAssetChart ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { styleName: 'chart-disclaimer' },
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' }),
            '\xA0This chart shows the percent of each plan option that is invested in fossil fuel bonds and stocks. The plan options at the top of the chart have the most exposure to fossil fuels, and the plan options at the bottom of the chart have the least exposure.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'chart-img-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: this.state.planWeightChartUrl,
                title: this.state.planWeightChartAlt,
                targetBlank: true
              },
              _react2.default.createElement('img', {
                src: this.state.planWeightChartUrl,
                alt: this.state.planWeightChartAlt,
                styleName: 'chart-img'
              }),
              _react2.default.createElement(
                'span',
                { styleName: 'chart-expand-label visible-xs' },
                'Click to enlarge',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-expand' })
              )
            )
          )
        ) :
        /* CHART IMAGE 2 - BY ASSET */
        _react2.default.createElement(
          'div',
          { styleName: 'chart-img-wrap' },
          _react2.default.createElement(
            'p',
            { styleName: 'chart-disclaimer' },
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' }),
            '\xA0This chart shows, for each plan option in the retirement plan, the amount in USD invested in fossil fuel bonds and stocks by plan participants via that fund. The plan options at the top of the chart account for the most money invested in fossil fuel bonds and stocks by plan participants, and the plan options at the bottom of the chart account for the least. In total, plan participants have ',
            fm(this.props.activePlan.ff_all_asset_both),
            ' invested in fossil fuels via these plan options.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'chart-img-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: this.state.planAssetChartUrl,
                title: this.state.planAssetChartAlt,
                targetBlank: true
              },
              _react2.default.createElement('img', {
                src: this.state.planAssetChartUrl,
                alt: this.state.planAssetChartAlt,
                styleName: 'chart-img'
              }),
              _react2.default.createElement(
                'span',
                { styleName: 'chart-expand-label visible-xs' },
                'Click to enlarge',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-expand' })
              )
            )
          )
        )
      );
    }
  }]);
  return PlanCharts;
}(_react.Component)) || _class17);
var PlanOptionsTableLayout = (_dec15 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec15(_class18 = function (_Component15) {
  (0, _inherits3.default)(PlanOptionsTableLayout, _Component15);

  function PlanOptionsTableLayout() {
    (0, _classCallCheck3.default)(this, PlanOptionsTableLayout);
    return (0, _possibleConstructorReturn3.default)(this, (PlanOptionsTableLayout.__proto__ || (0, _getPrototypeOf2.default)(PlanOptionsTableLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanOptionsTableLayout, [{
    key: 'render',
    value: function render() {
      if (!this.props.activePlan) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'plan-options-table-wrap' },
        _react2.default.createElement(
          'h3',
          { styleName: 'plan-summary-section-heading' },
          'PLAN INVESTMENT OPTIONS TABLE'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'hidden-xs hidden-sm' },
          _react2.default.createElement(PlanOptionsTableDesktop, { activePlan: this.props.activePlan })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'hidden-md hidden-lg' },
          _react2.default.createElement(PlanOptionsTableMobile, { activePlan: this.props.activePlan })
        )
      );
    }
  }]);
  return PlanOptionsTableLayout;
}(_react.Component)) || _class18);
var PlanOptionsTableDesktop = (_dec16 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec16(_class19 = function (_Component16) {
  (0, _inherits3.default)(PlanOptionsTableDesktop, _Component16);

  function PlanOptionsTableDesktop() {
    (0, _classCallCheck3.default)(this, PlanOptionsTableDesktop);
    return (0, _possibleConstructorReturn3.default)(this, (PlanOptionsTableDesktop.__proto__ || (0, _getPrototypeOf2.default)(PlanOptionsTableDesktop)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanOptionsTableDesktop, [{
    key: 'render',
    value: function render() {
      if (!this.props.activePlan) {
        return null;
      }
      var activePlan = this.props.activePlan;

      return _react2.default.createElement(
        'table',
        { styleName: 'plan-options-table' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement('th', { colSpan: '2' }),
            _react2.default.createElement(
              'th',
              { colSpan: '3' },
              _react2.default.createElement(
                'i',
                null,
                'Fossil fuel exposure'
              )
            ),
            _react2.default.createElement(
              'th',
              { colSpan: '3' },
              _react2.default.createElement(
                'i',
                null,
                'Fossil fuel plan investments'
              )
            ),
            _react2.default.createElement('th', null)
          ),
          _react2.default.createElement(
            'tr',
            null,
            /* THEAD SECOND TR */
            ['Plan option', 'Rated as', 'Bond', 'Equity', 'Total', 'Bond', 'Equity', 'Total', 'Total plan investments'].map(function (th, th_i) {
              var k = 'plan-option-table-th-' + th_i;
              return _react2.default.createElement(
                'th',
                { key: k },
                th
              );
            })
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            { styleName: 'table-total-row' },
            /* TOTAL ROW FOR MATCHED FUNDS */
            ['All matched funds', null, fp(activePlan.ff_all_weight_bond), fp(activePlan.ff_all_weight_equity), fp(activePlan.ff_all_weight_both), fm(activePlan.ff_all_asset_bond), fm(activePlan.ff_all_asset_equity), fm(activePlan.ff_all_asset_both), fm(activePlan.matched_fund_assets)].map(function (td, td_i) {
              var k = 'plan-option-table-matched-totals-' + td_i;
              return _react2.default.createElement(
                'td',
                { key: k },
                _react2.default.createElement(
                  'b',
                  null,
                  td
                )
              );
            })
          ),
          /* MATCHED PLAN OPTIONS AS ROWS */
          /* FOR EACH PLAN OPTION... */
          activePlan.plan_options_table.map(function (o, i3) {
            var _o = (0, _slicedToArray3.default)(o, 11),
                plan_option_name = _o[0],
                ticker = _o[1],
                fund_id = _o[2],
                investment_vehicle_id = _o[3],
                market_value = _o[4],
                ff_all_weight_equity = _o[5],
                ff_all_asset_equity = _o[6],
                ff_all_weight_bond = _o[7],
                ff_all_asset_bond = _o[8],
                ff_all_weight_both = _o[9],
                ff_all_asset_both = _o[10];
            // IF IT HAS NO FUND_ID, SKIP IT


            if (fund_id === '~') {
              return null;
            }
            // IF FUND_ID, IT'S MATCHED
            // RETURN A ROW WITH MORE DATA
            var _k = 'plan-option-table-' + 'matched-option-' + i3;
            return _react2.default.createElement(
              'tr',
              { key: _k, styleName: 'plan-option-table-row' },
              /* RETURN A <TD> WITH DATA */
              [plan_option_name, ticker, fp(ff_all_weight_bond), fp(ff_all_weight_equity), fp(ff_all_weight_both), fm(ff_all_asset_bond), fm(ff_all_asset_equity), fm(ff_all_asset_both), fm(market_value)].map(function (td, td_i) {
                var k = 'plan-option-table-' + 'matched-option-' + i3 + '-' + td_i;
                return _react2.default.createElement(
                  'td',
                  { key: k },
                  td
                );
              })
            );
          }),
          _react2.default.createElement(
            'tr',
            { styleName: 'table-disclaimer-row' },
            _react2.default.createElement(
              'th',
              { colSpan: '9' },
              _react2.default.createElement(
                'div',
                { styleName: 'table-disclaimer' },
                _react2.default.createElement(
                  'b',
                  null,
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' }),
                  '\xA0Unmatched funds'
                ),
                _react2.default.createElement('br', null),
                activePlan.unmatched_funds_count,
                ' plan options were not matched to any mutual fund, with ',
                fm(activePlan.unmatched_fund_assets),
                ' invested by plan participants, making up ',
                fp(activePlan.unmatched_fund_weight),
                ' of plan assets. Unmatched plan options are things like employee stock ownership funds, money market funds, and stable value funds, but could also include separately managed accounts where there is little or no transparency into fund holdings. ',
                _react2.default.createElement(
                  'b',
                  null,
                  'These plan options may include fossil fuel investments that aren\'t accounted for in the figures above.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'tr',
            { styleName: 'table-total-row' },
            _react2.default.createElement(
              'td',
              { colSpan: '8' },
              _react2.default.createElement(
                'b',
                null,
                'All unmatched funds'
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'b',
                null,
                fm(activePlan.unmatched_fund_assets)
              )
            )
          ),
          /* UNMATCHED PLAN OPTIONS AS ROWS 1 */
          /* FOR EACH PLAN OPTION... */
          activePlan.plan_options_table.map(function (o, i4) {
            console.log('hi here');
            console.log(o);
            var plan_option_name = o[0];
            var fund_id = o[2];
            var market_value = o[4];
            // IF IT HAS A FUND_ID, SKIP IT
            if (fund_id !== '~') {
              return null;
            }
            // IF NO FUND_ID, IT'S UNMATCHED
            // RETURN A ROW WITH LESS DATA
            var _k = 'plan-option-table-' + 'unmatched-option-' + i4;
            return _react2.default.createElement(
              'tr',
              { key: _k, styleName: 'plan-option-table-row' },
              _react2.default.createElement(
                'td',
                { colSpan: '8' },
                plan_option_name
              ),
              _react2.default.createElement(
                'td',
                null,
                fm(market_value)
              )
            );
          })
        )
      );
    }
  }]);
  return PlanOptionsTableDesktop;
}(_react.Component)) || _class19);
var PlanOptionsTableMobile = (_dec17 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec17(_class20 = function (_Component17) {
  (0, _inherits3.default)(PlanOptionsTableMobile, _Component17);

  function PlanOptionsTableMobile(props) {
    (0, _classCallCheck3.default)(this, PlanOptionsTableMobile);

    var _this22 = (0, _possibleConstructorReturn3.default)(this, (PlanOptionsTableMobile.__proto__ || (0, _getPrototypeOf2.default)(PlanOptionsTableMobile)).call(this, props));

    _this22.state = {};
    return _this22;
  }

  (0, _createClass3.default)(PlanOptionsTableMobile, [{
    key: 'opener',
    value: function opener(rowLabel) {
      var newState = {};
      newState[rowLabel] = !this.state[rowLabel];
      this.setState(newState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this23 = this;

      if (!this.props.activePlan) {
        return null;
      }
      var activePlan = this.props.activePlan;

      return _react2.default.createElement(
        'div',
        { styleName: 'plan-options-table-responsive-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'plan-options-table-responsive-row responsive-header-row' },
          _react2.default.createElement(
            'div',
            null,
            'Plan option'
          ),
          _react2.default.createElement(
            'div',
            null,
            'Fossil fuel bond exposure'
          ),
          _react2.default.createElement('div', null)
        ),
        _react2.default.createElement(
          'div',
          {
            styleName: 'plan-options-table-responsive-button-row responsive-total-row',
            onClick: function onClick() {
              _this23.opener('all-matched-funds');
            }
          },
          _react2.default.createElement(
            'div',
            null,
            'All matched funds'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'responsive-figure' },
            fp(activePlan.ff_all_weight_bond)
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-ellipsis-v' })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          this.state['all-matched-funds'] ? _react2.default.createElement(
            'div',
            { styleName: 'plan-options-table-responsive-more-results-row' },
            [['Fossil fuel exposure', null, 0, 1], ['Bond', fp(activePlan.ff_all_weight_bond), 1, 0], ['Equity', fp(activePlan.ff_all_weight_equity), 1, 0], ['Total', fp(activePlan.ff_all_weight_both), 1, 0], ['Fossil fuel investments', null, 0, 1], ['Bond', fm(activePlan.ff_all_asset_bond), 1, 0], ['Equity', fm(activePlan.ff_all_asset_equity), 1, 0], ['Total', fm(activePlan.ff_all_asset_both), 1, 0], ['Total plan investments', fm(activePlan.matched_fund_assets), 1, 0]].map(function (oLblVal, i7) {
              var _oLblVal = (0, _slicedToArray3.default)(oLblVal, 4),
                  lbl = _oLblVal[0],
                  val = _oLblVal[1],
                  isFigure = _oLblVal[2],
                  isItalic = _oLblVal[3];

              return _react2.default.createElement(
                'div',
                {
                  styleName: 'responsive-more-results-data-row',
                  key: 'all-matched-funds-responsive-more-results-data-row-' + i7
                },
                _react2.default.createElement(
                  'div',
                  { styleName: isItalic ? 'responsive-italic' : '' },
                  lbl
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: isFigure ? 'responsive-figure' : '' },
                  val
                )
              );
            })
          ) : null
        ),
        /* MATCHED PLAN OPTIONS AS ROWS */
        /* FOR EACH PLAN OPTION... */
        activePlan.plan_options_table.map(function (o, i5) {
          var _o2 = (0, _slicedToArray3.default)(o, 10),
              plan_option_name = _o2[0],
              ticker = _o2[1],
              fund_id = _o2[2],
              market_value = _o2[3],
              ff_all_weight_equity = _o2[4],
              ff_all_asset_equity = _o2[5],
              ff_all_weight_bond = _o2[6],
              ff_all_asset_bond = _o2[7],
              ff_all_weight_both = _o2[8],
              ff_all_asset_both = _o2[9];
          // IF IT HAS NO FUND_ID, SKIP IT


          if (fund_id === '~') {
            return null;
          }
          // IF FUND_ID, IT'S MATCHED
          // RETURN A ROW WITH MORE DATA
          var k = 'responsive-table-option-matched-' + i5;
          return _react2.default.createElement(
            'div',
            { key: k },
            _react2.default.createElement(
              'div',
              {
                styleName: 'plan-options-table-responsive-button-row',
                onClick: function onClick() {
                  _this23.opener('matched-' + i5);
                }
              },
              _react2.default.createElement(
                'div',
                null,
                plan_option_name
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'responsive-figure' },
                fp(ff_all_weight_bond)
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-ellipsis-v' })
              )
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              _this23.state['matched-' + i5] ? _react2.default.createElement(
                'div',
                { styleName: 'plan-options-table-responsive-more-results-row' },
                [['Rated as', ticker, 0, 0], ['Fossil fuel exposure', null, 0, 1], ['Bond', fp(ff_all_weight_bond), 1, 0], ['Equity', fp(ff_all_weight_equity), 1, 0], ['Total', fp(ff_all_weight_both), 1, 0], ['Fossil fuel investments', null, 0, 1], ['Bond', fm(ff_all_asset_bond), 1, 0], ['Equity', fm(ff_all_asset_equity), 1, 0], ['Total', fm(ff_all_asset_both), 1, 0], ['Total plan investments', fm(market_value), 1, 0]].map(function (oLblVal, i6) {
                  var _oLblVal2 = (0, _slicedToArray3.default)(oLblVal, 4),
                      lbl = _oLblVal2[0],
                      val = _oLblVal2[1],
                      isFigure = _oLblVal2[2],
                      isItalic = _oLblVal2[3];

                  return _react2.default.createElement(
                    'div',
                    {
                      styleName: 'responsive-more-results-data-row',
                      key: 'plan-option-responsive-more-results-data-row-' + i6
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: isItalic ? 'responsive-italic' : '' },
                      lbl
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: isFigure ? 'responsive-figure' : '' },
                      val
                    )
                  );
                })
              ) : null
            )
          );
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'plan-options-table-responsive-row responsive-header-row' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'table-disclaimer' },
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' }),
                '\xA0 Unmatched funds'
              ),
              _react2.default.createElement('br', null),
              activePlan.unmatched_funds_count,
              ' plan options were not matched to any mutual fund, with ',
              fm(activePlan.unmatched_fund_assets),
              ' invested by plan participants, making up ',
              fp(activePlan.unmatched_fund_weight),
              ' of plan assets. These plan options may include fossil fuel investments that aren\'t accounted for in the figures above.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'plan-options-table-responsive-row responsive-header-row' },
          _react2.default.createElement(
            'div',
            null,
            'Plan option'
          ),
          _react2.default.createElement(
            'div',
            null,
            'Total plan investments'
          ),
          _react2.default.createElement('div', null)
        ),
        _react2.default.createElement(
          'div',
          {
            styleName: 'plan-options-table-responsive-button-row responsive-total-row'
          },
          _react2.default.createElement(
            'div',
            null,
            'All unmatched funds'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'responsive-figure' },
            fm(activePlan.unmatched_fund_assets)
          ),
          _react2.default.createElement('div', null)
        ),
        /* UNMATCHED PLAN OPTIONS AS ROWS 2 */
        /* FOR EACH PLAN OPTION... */
        activePlan.plan_options_table.map(function (o, i5) {
          var _o3 = (0, _slicedToArray3.default)(o, 5),
              plan_option_name = _o3[0],
              ticker = _o3[1],
              fund_id = _o3[2],
              investment_vehicle_id = _o3[3],
              market_value = _o3[4];
          // IF IT HAS NO FUND_ID, SKIP IT


          if (fund_id !== '~') {
            return null;
          }
          // IF FUND_ID, IT'S MATCHED
          // RETURN A ROW WITH MORE DATA
          var k = 'responsive-table-option-matched-' + i5;
          return _react2.default.createElement(
            'div',
            { key: k },
            _react2.default.createElement(
              'div',
              {
                styleName: 'plan-options-table-responsive-button-row',
                onClick: function onClick() {
                  _this23.opener('matched-' + i5);
                }
              },
              _react2.default.createElement(
                'div',
                null,
                plan_option_name
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'responsive-figure' },
                fm(market_value)
              ),
              _react2.default.createElement('div', null)
            )
          );
        })
      );
    }
  }]);
  return PlanOptionsTableMobile;
}(_react.Component)) || _class20);
var PlanBondFundsTableLayout = (_dec18 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec18(_class21 = function (_Component18) {
  (0, _inherits3.default)(PlanBondFundsTableLayout, _Component18);

  function PlanBondFundsTableLayout(props) {
    (0, _classCallCheck3.default)(this, PlanBondFundsTableLayout);

    var _this24 = (0, _possibleConstructorReturn3.default)(this, (PlanBondFundsTableLayout.__proto__ || (0, _getPrototypeOf2.default)(PlanBondFundsTableLayout)).call(this, props));

    _this24.state = {
      planBondFundsOpen: false,
      planBondFundsData: [['Baird', 'Baird Core Plus Bond Fund', 0.493054, 0.072454, 0.146949], ['BlackRock/iShares', 'BlackRock Total Return Fund', 0.247943, 0.054641, 0.220376], ['BlackRock/iShares', 'iShares Intermediate Government/Credit Bond ETF', 0.326101, 0.039468, 0.121031], ['Dodge & Cox', 'Dodge & Cox Income Fund', 0.407703, 0.083717, 0.205337], ['Eaton Vance', 'Eaton Vance High Income Opportunities Fund', 0.865161, 0.133719, 0.15456], ['Fidelity Investments', 'Fidelity® Capital & Income Fund', 0.745349, 0.129826, 0.174181], ['Fidelity Investments', 'Fidelity® Government Income Fund', 0.0014, 0.0014, 1.0], ['Fidelity Investments', 'Fidelity® Inflation-Protected Bond Index Fund', 0.0, 0.0, 0.0], ['Fidelity Investments', 'Fidelity® Total Bond Fund', 0.346875, 0.058734, 0.169324], ['Fidelity Investments', 'Fidelity® Total Bond K6 Fund', 0.341398, 0.070594, 0.20678], ['Fidelity Investments', 'Fidelity® U.S. Bond Index Fund', 0.251279, 0.038861, 0.154653], ['Hartford Mutual Funds', 'The Hartford World Bond Fund', 0.084813, 0.013107, 0.154538], ['Metropolitan West Funds', 'Metropolitan West High Yield Bond Fund', 0.827335, 0.066153, 0.07996], ['Metropolitan West Funds', 'Metropolitan West Total Return Bond Fund', 0.251019, 0.017325, 0.069019], ['PGIM Investments', 'PGIM Total Return Bond Fund', 0.242999, 0.046194, 0.190098], ['PIMCO', 'PIMCO Income Fund', 0.042801, 0.009435, 0.220438], ['PIMCO', 'PIMCO Inflation Response Multi-Asset Fund', 0.0, 0.0, 0.0], ['PIMCO', 'PIMCO Low Duration Fund', 0.104526, 0.009559, 0.091448], ['PIMCO', 'PIMCO Real Return Fund', 0.003019, 1.2e-05, 0.004134], ['PIMCO', 'PIMCO Total Return Fund', 0.113876, 0.012424, 0.109102], ['PIMCO', 'PIMCO Total Return II Fund', 0.17802, 0.048347, 0.271579], ['SPDR State Street Global Advisors', 'SPDR® Portfolio TIPS ETF', 0.0, 0.0, 0.0], ['State Street Global Advisors', 'State Street Aggregate Bond Index Portfolio', 0.242708, 0.03708, 0.152776], ['T. Rowe Price', 'T. Rowe Price International Bond Fund', 0.107998, 0.010501, 0.097233], ['TCW', 'TCW Total Return Bond Fund', 0.00498, 0.0, 0.0], ['Vanguard', 'Vanguard GNMA Fund', 0.0, 0.0, 0.0], ['Vanguard', 'Vanguard High Yield Corporate Fund', 0.87513, 0.126553, 0.14461], ['Vanguard', 'Vanguard Inflation-Protected Securities Fund', 0.0, 0.0, 0.0], ['Vanguard', 'Vanguard Intermediate-Term Bond Index Fund', 0.382505, 0.054052, 0.141311], ['Vanguard', 'Vanguard Short Term Investment Grade Fund', 0.841843, 0.109238, 0.12976], ['Vanguard', 'Vanguard Short-Term Bond Index Fund', 0.282324, 0.029389, 0.104097], ['Vanguard', 'Vanguard Short-Term Inflation-Protected Securities Index Fund', 0.0, 0.0, 0.0], ['Vanguard', 'Vanguard Total Bond Market Index Fund', 0.271262, 0.041361, 0.152478], ['Vanguard', 'Vanguard Total International Bond Index Fund', 0.113145, 0.011646, 0.102927], ['Vanguard', 'Vanguard Wellesley® Income Fund', 0.441257, 0.075057, 0.170098], ['Victory Capital', 'Victory INCORE Fund for Income', 0.0, 0.0, 0.0]]
    };
    return _this24;
  }

  (0, _createClass3.default)(PlanBondFundsTableLayout, [{
    key: 'render',
    value: function render() {
      var _this25 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'button',
          {
            styleName: 'section-slidedown-button',
            onClick: function onClick(e) {
              _this25.setState({
                planBondFundsOpen: !_this25.state.planBondFundsOpen
              });
            }
          },
          _react2.default.createElement(
            'h2',
            { styleName: 'section-slidedown-label' },
            'See all plan bond funds'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section-slidedown-icon' },
            _react2.default.createElement(_components.LinkIcon, { faclass: this.state.planBondFundsOpen ? 'fa-angle-up' : 'fa-angle-down' })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          this.state.planBondFundsOpen ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'The table below lists the 36 bond funds found within the 43 retirement plans analyzed. None of the bond funds in these plans were sustainable investments that seek to mitigate climate risk to the portfolio. Some of these bond funds invest solely in treasury bonds or mortgage bonds, and have 0% exposure to the corporate bond asset class, and thus have 0% fossil fuel bond exposure and concentration. Information on the target date funds in these retirement plans ',
              _react2.default.createElement(
                _reactScroll.Link,
                {
                  activeClass: 'active-scroll-link',
                  to: 'target-dates',
                  spy: true,
                  smooth: true,
                  offset: -70,
                  duration: 500
                },
                _react2.default.createElement(
                  'span',
                  { styleName: 'red-link' },
                  'can be found below'
                )
              ),
              '.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hidden-xs hidden-sm' },
              _react2.default.createElement(PlanBondFundsTableDesktop, {
                planBondFundsData: this.state.planBondFundsData
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hidden-md hidden-lg' },
              _react2.default.createElement(PlanBondFundsTableMobile, {
                planBondFundsData: this.state.planBondFundsData
              })
            )
          ) : null
        )
      );
    }
  }]);
  return PlanBondFundsTableLayout;
}(_react.Component)) || _class21);
var PlanBondFundsTableDesktop = (_dec19 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec19(_class22 = function (_Component19) {
  (0, _inherits3.default)(PlanBondFundsTableDesktop, _Component19);

  function PlanBondFundsTableDesktop(props) {
    (0, _classCallCheck3.default)(this, PlanBondFundsTableDesktop);
    return (0, _possibleConstructorReturn3.default)(this, (PlanBondFundsTableDesktop.__proto__ || (0, _getPrototypeOf2.default)(PlanBondFundsTableDesktop)).call(this, props));
  }

  (0, _createClass3.default)(PlanBondFundsTableDesktop, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'table',
        { styleName: 'plan-options-table' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              'Asset manager'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Fund name'
            ),
            _react2.default.createElement(
              'th',
              null,
              '% of fund invested in corporate bonds'
            ),
            _react2.default.createElement(
              'th',
              null,
              '% of fund invested in fossil fuel corporate bonds (exposure)'
            ),
            _react2.default.createElement(
              'th',
              null,
              '% of corporate bond holdings labeled fossil fuel (concentration)'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          this.props.planBondFundsData.map(function (e, i) {
            var _e2 = (0, _slicedToArray3.default)(e, 5),
                fam = _e2[0],
                name = _e2[1],
                cbond_ex = _e2[2],
                ff_ex = _e2[3],
                ff_conc = _e2[4];

            return _react2.default.createElement(
              'tr',
              { styleName: 'plan-option-table-row' },
              _react2.default.createElement(
                'td',
                null,
                fam
              ),
              _react2.default.createElement(
                'td',
                null,
                name
              ),
              _react2.default.createElement(
                'td',
                null,
                fp(cbond_ex)
              ),
              _react2.default.createElement(
                'td',
                null,
                fp(ff_ex)
              ),
              _react2.default.createElement(
                'td',
                null,
                fp(ff_conc)
              )
            );
          })
        )
      );
    }
  }]);
  return PlanBondFundsTableDesktop;
}(_react.Component)) || _class22);
var PlanBondFundsTableMobile = (_dec20 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec20(_class23 = function (_Component20) {
  (0, _inherits3.default)(PlanBondFundsTableMobile, _Component20);

  function PlanBondFundsTableMobile(props) {
    (0, _classCallCheck3.default)(this, PlanBondFundsTableMobile);

    var _this27 = (0, _possibleConstructorReturn3.default)(this, (PlanBondFundsTableMobile.__proto__ || (0, _getPrototypeOf2.default)(PlanBondFundsTableMobile)).call(this, props));

    _this27.state = {};
    return _this27;
  }

  (0, _createClass3.default)(PlanBondFundsTableMobile, [{
    key: 'opener',
    value: function opener(rowLabel) {
      var newState = {};
      newState[rowLabel] = !this.state[rowLabel];
      this.setState(newState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this28 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'plan-options-table-responsive-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'plan-options-table-responsive-row responsive-header-row' },
          _react2.default.createElement(
            'div',
            null,
            'Bond fund'
          ),
          _react2.default.createElement('div', null)
        ),
        /* MATCHED PLAN OPTIONS AS ROWS */
        /* FOR EACH PLAN OPTION... */
        this.props.planBondFundsData.map(function (e, i8) {
          var _e3 = (0, _slicedToArray3.default)(e, 5),
              fam = _e3[0],
              name = _e3[1],
              cbond_ex = _e3[2],
              ff_ex = _e3[3],
              ff_conc = _e3[4];

          var k = 'responsive-table-all-bond-funds-' + i8;
          return _react2.default.createElement(
            'div',
            { key: k, styleName: 'even-or-odd' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'plan-options-table-responsive-button-row',
                onClick: function onClick() {
                  _this28.opener('all-bond-funds-' + i8);
                }
              },
              _react2.default.createElement(
                'div',
                null,
                name
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-ellipsis-v' })
              )
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              _this28.state['all-bond-funds-' + i8] ? _react2.default.createElement(
                'div',
                { styleName: 'plan-options-table-responsive-more-results-row' },
                [
                // [lbl, val, isFigure, isItalic]
                ['Asset manager', fam, 0, 0], ['% of fund invested in corporate bonds', fp(cbond_ex), 1, 0], ['% of fund invested in fossil fuel corporate bonds (exposure)', fp(ff_ex), 1, 0], ['% of corporate bond holdings labeled fossil fuel (concentration)', fp(ff_conc), 1, 0]].map(function (oLblVal, i9) {
                  var _oLblVal3 = (0, _slicedToArray3.default)(oLblVal, 4),
                      lbl = _oLblVal3[0],
                      val = _oLblVal3[1],
                      isFigure = _oLblVal3[2],
                      isItalic = _oLblVal3[3];

                  return _react2.default.createElement(
                    'div',
                    {
                      styleName: 'responsive-more-results-data-row',
                      key: 'all-bond-funds-responsive-more-results-data-row-' + i9
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: isItalic ? 'responsive-italic' : '' },
                      lbl
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: isFigure ? 'responsive-figure' : '' },
                      val
                    )
                  );
                })
              ) : null
            )
          );
        })
      );
    }
  }]);
  return PlanBondFundsTableMobile;
}(_react.Component)) || _class23);

//
// <TargetDateSelect> component
// Includes: <Select> and onTdSelect()
//             to select an active TD series,
//           <TargetDateResults> to display results
//             for active TD series
//

var TargetDateSelect = (_dec21 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec21(_class24 = function (_Component21) {
  (0, _inherits3.default)(TargetDateSelect, _Component21);

  function TargetDateSelect(props) {
    (0, _classCallCheck3.default)(this, TargetDateSelect);

    var _this29 = (0, _possibleConstructorReturn3.default)(this, (TargetDateSelect.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSelect)).call(this, props));

    _this29.onTdSelect = function (val) {
      // similar logic as onPlanSelect
      // except there is a default (all 2025 funds)
      // so there is a setTimeout to go back to default
      // even if there is no val selected
      if (_this29.state.tdTimeout) {
        clearTimeout(_this29.state.tdTimeout);
      }
      if (val) {
        _this29.setState({
          tdSelected: val,
          tdLoading: true,
          tdTimeout: setTimeout(function () {
            _this29.setState({
              tdLoading: false
            });
          }, 500)
        });
      } else {
        _this29.setState({
          tdSelected: _this29.state.defaultTdSelectOption,
          tdLoading: true,
          tdTimeout: setTimeout(function () {
            _this29.setState({
              tdLoading: false
            });
          }, 500)
        });
      }
    };

    var defaultTdSelectOption = {
      name: '2025 fund for all series',
      label: '2025 fund for all series'
    };
    var tdSelectOptions = [defaultTdSelectOption];
    (0, _keys2.default)(_config2.default.targetDateBondsSource).map(function (key, i) {
      tdSelectOptions.push({ name: key, label: key });
      return null;
    });
    _this29.state = {
      tdSelected: defaultTdSelectOption,
      tdLoading: false,
      tdTimeout: null,
      tdSelectOptions: tdSelectOptions,
      defaultTdSelectOption: defaultTdSelectOption
    };
    return _this29;
  }

  (0, _createClass3.default)(TargetDateSelect, [{
    key: 'render',
    value: function render() {
      var iconTargetDates = require('../../../static/images/icon-target-dates.png');
      // select active TD
      var activeTdKey = null;
      if (this.state.tdSelected.name !== '2025 fund for all series') {
        activeTdKey = this.state.tdSelected.name;
      }
      //
      return _react2.default.createElement(
        'div',
        { id: 'target-dates', styleName: 'target-date-select-wrap' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'plan-select-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'plan-select-flex' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  null,
                  'Target date fund series'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Many 401(k)s are based around target date fund series as the default investment option. Select a target date series to see how much it has invested in fossil fuel bonds and stocks across the different dates.'
                ),
                _react2.default.createElement(_reactSelect2.default, {
                  name: 'td-select',
                  value: this.state.tdSelected,
                  options: this.state.tdSelectOptions,
                  onChange: this.onTdSelect
                })
              ),
              _react2.default.createElement('img', {
                styleName: 'plan-select-img',
                src: iconTargetDates,
                alt: 'Target date funds'
              })
            ),
            _react2.default.createElement(TargetDateResults, { tdLoading: this.state.tdLoading, activeTdKey: activeTdKey }),
            _react2.default.createElement(
              'div',
              { styleName: 'target-date-results-disclaimer' },
              '* To see the figures for these charts, download the dataset in the ',
              _react2.default.createElement(
                _reactScroll.Link,
                {
                  activeClass: 'active-scroll-link',
                  to: 'methodology',
                  spy: true,
                  smooth: true,
                  offset: -70,
                  duration: 500
                },
                _react2.default.createElement(
                  'span',
                  { styleName: 'red-link' },
                  'methodology section'
                )
              ),
              '.'
            )
          ),
          _react2.default.createElement(_components.ScrollToTop, { color: 'red' })
        )
      );
    }
  }]);
  return TargetDateSelect;
}(_react.Component)) || _class24);

//
// <TargetDateResults> component
// Display: chart image for all TD series, 2025 fund,
//          chart images for specific TD series,
//            if there is an active TD series
// @param activeTdKey: Key for the active TD series
// @param tdLoading: T/F to show loading spinner. Controlled by timeout
//                   in <TargetDateSelect> onTdSelect()
//

var TargetDateResults = (_dec22 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec22(_class26 = (_temp3 = _class27 = function (_Component22) {
  (0, _inherits3.default)(TargetDateResults, _Component22);

  function TargetDateResults() {
    (0, _classCallCheck3.default)(this, TargetDateResults);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateResults.__proto__ || (0, _getPrototypeOf2.default)(TargetDateResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(TargetDateResults, [{
    key: 'render',
    value: function render() {
      var urlPrefix = 'https://iyv-charts.s3-us-west-2.amazonaws.com/fossil_fuel_bonds/';
      var allTdsWeightChartUrl = urlPrefix + '2025 Fund of Target Date Series fossil fuel bonds weight ' + currYYYYMM + '.png';
      var allTdsWeightChartAlt = '2025 fund of target date series weight chart';
      //
      var tdWeightChartUrl = null;
      var tdWeightChartAlt = null;
      if (this.props.activeTdKey) {
        tdWeightChartUrl = '' + urlPrefix + this.props.activeTdKey + ' fossil fuel bonds weight ' + currYYYYMM + '.png';
        tdWeightChartAlt = this.props.activeTdKey + ' weight chart';
      }
      //
      return _react2.default.createElement(
        'div',
        null,
        /* LOADING ICON DURING PLAN SELECT TIMEOUT */
        this.props.tdLoading ? _react2.default.createElement(
          'div',
          { styleName: 'td-loader-wrap' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, position: 'relative' },
            loaded: false
          })
        ) : null,
        /* CHART IMAGE FOR ALL TARGET DATE SERIES */
        !this.props.tdLoading && !this.props.activeTdKey ? _react2.default.createElement(
          'div',
          { styleName: 'td-chart-col' },
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-col' },
            _react2.default.createElement(
              'h3',
              { styleName: 'plan-summary-section-heading' },
              '2025 FUNDS OF POPULAR TARGET DATE SERIES'
            )
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'chart-disclaimer' },
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' }),
            '\xA0This chart compares 10 popular target date series using the 2025 fund. Those towards the top of the chart have more fossil fuel exposure in the 2025 fund, and those towards the bottom have less exposure. The 2025 fund is used for the comparison as it is more bond-heavy, being marketed to people who are nearing retirement.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'chart-img-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: allTdsWeightChartUrl,
                title: '2025 series weight chart',
                targetBlank: true
              },
              _react2.default.createElement('img', {
                src: allTdsWeightChartUrl,
                alt: allTdsWeightChartAlt,
                styleName: 'chart-img'
              }),
              _react2.default.createElement(
                'span',
                { styleName: 'chart-expand-label visible-xs' },
                'Click to enlarge',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-expand' })
              )
            )
          )
        ) : null,
        /* CHART IMAGE TD SERIES - BY WEIGHT */
        !this.props.tdLoading && this.props.activeTdKey ? _react2.default.createElement(
          'div',
          { styleName: 'td-chart-col' },
          _react2.default.createElement(
            'div',
            { styleName: 'plan-summary-col' },
            _react2.default.createElement(
              'h3',
              { styleName: 'plan-summary-section-heading' },
              'SERIES NAME'
            ),
            _react2.default.createElement(
              'p',
              null,
              this.props.activeTdKey
            )
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'chart-disclaimer' },
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' }),
            '\xA0This chart shows the percent of each fund in the target date series that is invested in fossil fuel bonds and stocks. The funds at the top of the chart are marketed at people further from retirement, and are the most stock-heavy, and the funds at the bottom of the chart are marketed at people closer to retirement, and are more bond-heavy.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'chart-img-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: tdWeightChartUrl,
                title: tdWeightChartAlt,
                targetBlank: true
              },
              _react2.default.createElement('img', {
                src: tdWeightChartUrl,
                alt: tdWeightChartAlt,
                styleName: 'chart-img-td'
              }),
              _react2.default.createElement(
                'span',
                { styleName: 'chart-expand-label visible-xs' },
                'Click to enlarge',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-expand' })
              )
            )
          )
        ) : null
      );
    }
  }]);
  return TargetDateResults;
}(_react.Component), _class27.propTypes = {
  activeTdKey: _react.PropTypes.string,
  tdLoading: _react.PropTypes.bool
}, _temp3)) || _class26);

//
// <Solutions> component
// Display: text of suggested solutions
// Includes: <BulletAccordion> of suggested solutions
//

var Solutions = (_dec23 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec23(_class28 = function (_Component23) {
  (0, _inherits3.default)(Solutions, _Component23);

  function Solutions() {
    (0, _classCallCheck3.default)(this, Solutions);
    return (0, _possibleConstructorReturn3.default)(this, (Solutions.__proto__ || (0, _getPrototypeOf2.default)(Solutions)).apply(this, arguments));
  }

  (0, _createClass3.default)(Solutions, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'solutions-wrap', id: 'recommendations' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Recommendations'
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'solutions-col-left' },
                _react2.default.createElement(
                  'p',
                  null,
                  'The steps retirement plan administrators should take to address the risk of fossil fuel corporate bonds in their plans are similar to the steps they should take to address the risk of fossil fuel stocks. It is the responsibility of every company to ensure that the retirement plan offers sustainable investments.'
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'solutions-col-right' },
                _react2.default.createElement(BulletAccordion, { bullets: [['Add climate-safe bond funds', _react2.default.createElement(
                    'div',
                    null,
                    'While treasury or other government bond fund options may provide a way for plan participants to invest in bonds without exposure to fossil fuel corporate bonds, they may not be appropriate for all investors. A better solution is to offer diversified bond funds that hold corporate bonds but reduce exposure to carbon intense sectors on the basis of climate risk. ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        xstrong: true,
                        to: 'https://charts.ussif.org/mfpc',
                        title: 'Sustainable Investment Mutual Funds and ETFs Chart'
                      },
                      'The Forum for Sustainable and Responsible Investment'
                    ),
                    ' has a list of sustainably invested funds, including bond funds, many of which seek to mitigate climate risk.'
                  )], ['Reduce climate risk of corporate bond holdings in default option', 'The default option generally commands a significant amount of the plan assets: new plan participants often have their contributions automatically allocated to the default, and many never switch. This makes it critical that exposure to climate-risky fossil fuel corporate bonds are reduced in these funds, so employees are not automatically having their savings invested in financing the climate crisis.'], ['Engage asset managers', 'Asset managers are responsible for offering fund portfolios to retirement plan administrators that meet the financial needs of employees. If asset managers like Vanguard and BlackRock aren\'t providing appropriate bond fund options that reduce exposure to climate-risky fossil fuel corporate bonds, companies should let them know that their employees deserve climate-safe investments.']] })
              )
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(Contacts, null)
        )
      );
    }
  }]);
  return Solutions;
}(_react.Component)) || _class28);

//
// <Contacts> component
// Display: link to contact form
// Includes: <SignupForm> component
//

var Contacts = (_dec24 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec24(_class29 = function (_Component24) {
  (0, _inherits3.default)(Contacts, _Component24);

  function Contacts() {
    (0, _classCallCheck3.default)(this, Contacts);
    return (0, _possibleConstructorReturn3.default)(this, (Contacts.__proto__ || (0, _getPrototypeOf2.default)(Contacts)).apply(this, arguments));
  }

  (0, _createClass3.default)(Contacts, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 6, lg: 6 },
            _react2.default.createElement(
              'div',
              { styleName: 'contact-col-left' },
              _react2.default.createElement(
                'h3',
                null,
                'Questions?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If you have questions about your company\'s retirement plan, get in touch.'
              ),
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.contact, title: 'Contact As You Sow', redbutton: true },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'solutions-contact-link' },
                  'Contact us',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 6, lg: 6 },
            _react2.default.createElement(
              'div',
              { styleName: 'contact-col-right ' },
              _react2.default.createElement(
                'h3',
                null,
                'Sign up for updates'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We\'ll let you know when we add new companies, new funds, and new features.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'solutions-col-signup' },
                _react2.default.createElement(_components.SignupForm, { url: '344561_46053pi_344561_46053', id: '344561_46053pi_344561_46053' })
              )
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.ScrollToTop, { color: 'red' })
      );
    }
  }]);
  return Contacts;
}(_react.Component)) || _class29);

//
// <Methodology> component
// Display text of methodology
// Display link to spreadsheet of bulk results
//

var Methodology = (_dec25 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec25(_class30 = function (_Component25) {
  (0, _inherits3.default)(Methodology, _Component25);

  function Methodology(props) {
    (0, _classCallCheck3.default)(this, Methodology);

    var _this33 = (0, _possibleConstructorReturn3.default)(this, (Methodology.__proto__ || (0, _getPrototypeOf2.default)(Methodology)).call(this, props));

    _this33.state = {
      methodologyOpen: false,
      industryListOpen: false
    };
    return _this33;
  }

  (0, _createClass3.default)(Methodology, [{
    key: 'render',
    value: function render() {
      var _this34 = this;

      return _react2.default.createElement(
        'div',
        { id: 'methodology', styleName: 'methodology' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Methodology'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'h3',
            { styleName: 'methodology-spreadsheet-download' },
            _react2.default.createElement(
              _components.Link,
              {
                to: 'https://iyv-charts.s3.us-west-2.amazonaws.com/files/Fossil+fuel+bonds+In+401ks+-+As+You+Sow+-+dataset+2023.xlsx',
                title: 'Fossil fuel bonds In 401ks - As You Sow - dataset 2023.xlsx'
              },
              'Download dataset',
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-file-excel-o' }),
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-download' })
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'p',
            null,
            'The results above are based on an analysis of the holdings of mutual funds found in retirement plans of major companies, as well as popular target date funds series used as the default investment option in hundreds of other retirement plans.'
          ),
          _react2.default.createElement(
            'button',
            {
              styleName: 'section-slidedown-button',
              onClick: function onClick() {
                _this34.setState({
                  methodologyOpen: !_this34.state.methodologyOpen
                });
              }
            },
            _react2.default.createElement(
              'h2',
              { styleName: 'section-slidedown-label' },
              'See the full methodology'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'section-slidedown-icon' },
              _react2.default.createElement(_components.LinkIcon, { faclass: this.state.methodologyOpen ? 'fa-angle-up' : 'fa-angle-down' })
            )
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state.methodologyOpen ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                null,
                'AS-OF DATE'
              ),
              _react2.default.createElement(
                'p',
                null,
                'This analysis was released in May 2023, using the most recent fund data and retirement plan data available. Fund portfolios are reported monthly or quarterly; retirement plan data is reported annually. For most retirement plans, the data was released in 2022, representing plan options and assets as of 31 December 2021. For most fund portfolios, the data was released at the end of April 2023, or in the few months prior.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'RETIREMENT PLANS'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The data on retirement plan options is the same used in the equity analysis in the main Retirement Plan Sustainability Scorecard. For more information on how this data is collected from Form 5500 filings on the Department of Labor website, and matched to mutual fund data, see our ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.methodology, title: 'Methodology' },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red-link' },
                    'main methodology page'
                  )
                ),
                '.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'CORPORATE BONDS'
              ),
              _react2.default.createElement(
                'p',
                null,
                'For the purposes of this analysis, as \u201Ccorporate bonds\u201D we considered different kinds of debt issued by a company in order for it to raise capital. This includes traditional corporate bonds, convertible bonds, corporate inflation-protected bonds, commercial paper, capital-contingent bonds, contingent convertible bonds, and some preferred stock (which are often treated like bonds by investors). Because some fossil fuel companies and projects are state-owned, we also included government agency debt, excluding mortgage issuers like Fannie Mae.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Bonds that are not part of this analysis include government bonds (e.g. treasury and muni bonds), mortgage bonds, asset-backed bonds like Collateral Loan Obligations, and more complex securities like derivatives, futures, options, warrants, structured products, and swaps.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'TRACKING FOSSIL FUEL BONDS'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These corporate bond holdings are then filtered down to fossil fuel companies. The fossil fuel companies searched for include all companies on our ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#fossilfuels', title: 'Publicly-traded companies: Fossil fuels' },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red-link' },
                    'publicly-traded fossil fuel screen'
                  )
                ),
                ', as well as non-publicly-traded companies operating in fossil fuel industries. The industry classifications used to identify fossil fuel companies include Standard Industrial Classification (SIC), Industry Classification Benchmark (ICB), and Morningstar industry classifications. The full list of industries classified as fossil fuel can be seen below.'
              ),
              _react2.default.createElement(
                'button',
                {
                  styleName: 'methodology-industry-list-btn',
                  onClick: function onClick() {
                    _this34.setState({
                      industryListOpen: !_this34.state.industryListOpen
                    });
                  }
                },
                'See fossil fuel industries',
                _react2.default.createElement(_components.LinkIcon, { faclass: this.state.industryListOpen ? 'fa-angle-down' : 'fa-angle-right' })
              ),
              _react2.default.createElement(
                _reactSlidedown.SlideDown,
                null,
                this.state.industryListOpen ? _react2.default.createElement(
                  'ul',
                  { styleName: 'methodology-industry-list' },
                  ['Bituminous coal & lignite mining', 'Bituminous coal & lignite surface mining', 'Bituminous coal underground mining', 'Coal and other minerals and ores', 'Coal mining', 'Coal mining services', 'Coking coal', 'Crude petroleum & natural gas', 'Crude petroleum pipelines', 'Drilling oil & gas wells', 'Electric services', 'Electric, gas & sanitary services', 'Equipment and services for oil and gas extraction', 'Exploration&production', 'Gas & other services combined', 'Liquefied petroleum gas dealers', 'Miscellaneous products of petroleum & coal', 'Natural gas distribution', 'Natural gas liquids', 'Natural gas transmisison & distribution', 'Natural gas transmission', 'Oil & gas', 'Oil & gas drilling', 'Oil & gas E&P', 'Oil & gas equipment & services', 'Oil & gas field exploration services', 'Oil & gas field machinery & equipment', 'Oil & gas field services, NEC', 'Oil & gas integrated', 'Oil & gas midstream', 'Oil & gas refining & marketing', 'Oil and gas extraction', 'Oil and gas extraction and refining', 'Petroleum and coal products', 'Petroleum refining', 'Pipelines (no natural gas)', 'Pipelines', 'Power', 'Refined petroleum pipelines', 'Thermal coal', 'Utilities', 'Utilities-diversified', 'Utilities-independent power producers', 'Utilities-regulated electric', 'Utilities-regulated gas', 'Water, heat and gas supply', 'Wholesale-petroleum & petroleum products (no bulk stations)', 'Wholesale-petroleum bulk stations & terminals'].map(function (e, i10) {
                    return _react2.default.createElement(
                      'li',
                      { key: 'fossil-fuel-bond-industry-' + i10 },
                      e
                    );
                  })
                ) : null
              ),
              _react2.default.createElement(
                'p',
                null,
                'For the utility and electric services industries, any companies in these categories that are engaged in 100% renewable operations, pure transmission, or otherwise don\'t distribute gas or burn fossil fuels to generate power were not considered \u201Cfossil fuel\u201D for the purposes of this analysis. We also excluded a small number of utilities that have fossil fuel operations but meet the criteria for inclusion on our ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://fossilfreefunds.org/clean-200',
                    title: 'Clean200'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red-link' },
                    'Clean200 screen'
                  )
                ),
                ' - USD revenue of at least $1 billion, and over 50% of total revenues are from green sources, as measured by Corporate Knights Research.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'In addition to industry classifications, several lists from external researchers are used to identify fossil fuel companies. These include the ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://www.ffisolutions.com/research-analytics-index-solutions/research-screening/the-carbon-underground-200/',
                    title: 'Carbon Underground 200'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red-link' },
                    'Carbon Underground 200'
                  )
                ),
                ' from FFI, the ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://coalexit.org/',
                    title: 'Global Coal Exit List (GCEL)'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red-link' },
                    'Global Coal Exit List (GCEL)'
                  )
                ),
                ' and ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://gogel.org/',
                    title: 'Global Oil/Gas Exit List (GOGEL)'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red-link' },
                    'Global Oil/Gas Exit List (GOGEL)'
                  )
                ),
                ' from Urgewald, and the ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://www.toxicbonds.org/toxic-bonds',
                    title: 'Toxic Bonds Dirty 30'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'red-link' },
                    'Toxic Bonds Dirty 30'
                  )
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'methodology-callout-p' },
                _react2.default.createElement(
                  'b',
                  null,
                  'What about \u201Cgreen bonds\u201D?'
                ),
                ' For this analysis, bonds were sorted by issuer, not by project. This means any bonds issued by these companies were considered "fossil fuel corporate" bonds, even if the bonds are marketed as "green bonds". Green bonds are intended to finance projects that contribute positively to the environment or the climate. However, the \u2018green finance\u2019 label is highly contested, especially when it comes to companies also involved in the fossil fuel industry.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'CALCULATING EXPOSURE AND CONCENTRATION'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Once retirement plan options are matched to appropriate mutual funds, and fossil fuel corporate bond holdings identified, exposure is calculated for each mutual fund (defined as the percent of fund assets invested in holdings classified as fossil fuel corporate bonds).'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'methodology-callout-p' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Long holdings only:'
                ),
                ' All exposure and concentration statistics in this analysis are based on long-position holdings only. Short positions and liabilities are ignored.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Once each mutual fund has the exposure calculated, the figures are applied to the retirement plan options. Each retirement plan option has some amount of assets ($USD) invested in it by plan participants. Using the fund-level exposures, we calculate summary statistics for each retirement plan:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Investments:'
                  ),
                  ' The amount of assets ($USD) invested by plan participants in fossil fuel corporate bonds across all plan options'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Exposure:'
                  ),
                  ' The percent of all plan assets classified as fossil fuel corporate bonds'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Concentration:'
                  ),
                  ' The percent of assets classified as fossil fuel within corporate bond holdings'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'The same statistics for equity investments in fossil fuels, already collected for the main Retirement Plan Sustainability Scorecard, are included here for comparison.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'For each retirement plan, we identify the top 10 companies found within fossil fuel corporate bond holdings across all plan options.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'For each retirement plan, we show two bar charts:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Percent:'
                  ),
                  ' Showing the exposure percent of each plan option to fossil fuel stocks and corporate bonds'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    '$USD:'
                  ),
                  ' Showing the total assets invested by plan participants in fossil fuel stocks and corporate bonds in each plan option'
                )
              ),
              _react2.default.createElement(
                'h3',
                null,
                'TARGET DATE SERIES'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We compare the fossil fuel stock and bond exposure of 10 popular target date series using the 2025 fund from each series. The 2025 fund is used for the comparison as it is more bond-heavy, being marketed to people who are nearing retirement. Those fund series towards the top of the chart have more fossil fuel exposure in the 2025 fund, and those towards the bottom have less exposure.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'For each target date series, we show a chart comparing the fossil fuel stock and bond exposure of the various funds within the series across target dates (2025, 2030, 2035, etc.). Most fund series have more fossil fuel corporate bond exposure as the target dates near the current date.'
              ),
              _react2.default.createElement(_components.ScrollToTop, { color: 'red' })
            ) : null
          )
        )
      );
    }
  }]);
  return Methodology;
}(_react.Component)) || _class30);

//
// <FossilFuelBondsIn401ks> component
// Main page layout
//

var FossilFuelBondsIn401ks = (_dec26 = (0, _reactCssModules2.default)(_FossilFuelBondsIn401ks2.default, { allowMultiple: true }), _dec26(_class31 = function (_Component26) {
  (0, _inherits3.default)(FossilFuelBondsIn401ks, _Component26);

  function FossilFuelBondsIn401ks(props) {
    (0, _classCallCheck3.default)(this, FossilFuelBondsIn401ks);

    var _this35 = (0, _possibleConstructorReturn3.default)(this, (FossilFuelBondsIn401ks.__proto__ || (0, _getPrototypeOf2.default)(FossilFuelBondsIn401ks)).call(this, props));

    _this35.state = {
      title: 'Fossil Fuel Bonds in 401(k)s',
      description: 'If there are fossil fuel bonds in your 401(k), ' + 'you\'re effectively lending your retirement savings ' + 'to companies so they can mine for coal and drill ' + 'for oil.',
      url: _config2.default.domain + _config2.default.routes.fossilFuelBondsIn401ks
    };
    return _this35;
  }

  (0, _createClass3.default)(FossilFuelBondsIn401ks, [{
    key: 'render',
    value: function render() {
      var socialShareUrl = _config2.default.domain + _fossilFuelBondsSocialShare2.default.replace(/.*dist/, '/dist');
      return _react2.default.createElement(
        'div',
        { styleName: 'page', id: 'top' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(_reactHelmet2.default, { meta: [{ property: 'og:image', content: socialShareUrl }, { property: 'twitter:image', content: socialShareUrl }] }),
        _react2.default.createElement(LedeNav, { title: this.state.title }),
        _react2.default.createElement(TheIssue, null),
        _react2.default.createElement(KeyFindings, null),
        _react2.default.createElement(PlanSection, null),
        _react2.default.createElement(TargetDateSelect, null),
        _react2.default.createElement(Solutions, null),
        _react2.default.createElement(Methodology, null)
      );
    }
  }]);
  return FossilFuelBondsIn401ks;
}(_react.Component)) || _class31);
exports.default = FossilFuelBondsIn401ks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FossilFuelBondsIn401ks/FossilFuelBondsIn401ks.js
// module id = 1478
// module chunks = 0